"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const clsx_1 = __importDefault(require("clsx"));
const _1 = require(".");
const core_1 = require("@material-ui/core");
const useStyles = (0, core_1.makeStyles)((theme) => ({
    body: {
        minHeight: 'calc(100vh - 100px)',
        backgroundColor: '#F1F2F5',
    },
}));
const Wrapper = ({ children, isFetching, isBusy, navBar, message, container = true, classes, version, }) => {
    const myClasses = useStyles();
    return (react_1.default.createElement(_1.ThemeWrapper, null,
        react_1.default.createElement(react_1.default.Fragment, null,
            navBar,
            react_1.default.createElement(core_1.Box, { className: (0, clsx_1.default)(myClasses.body, classes === null || classes === void 0 ? void 0 : classes.wrapperBody, 'wrapper'), pb: 4 }, container ? (react_1.default.createElement(core_1.Container, { maxWidth: "lg", className: 'root-container' }, children)) : (react_1.default.createElement(react_1.default.Fragment, null, children))),
            react_1.default.createElement(core_1.Box, null,
                react_1.default.createElement(_1.Footer, { links: [
                        { href: '#', label: 'Contact' },
                        { href: '#', label: 'Sitemap' },
                        { href: '#', label: 'Policy' },
                        { href: '#', label: 'Privacy' },
                    ], isHidden: isFetching, version: version })),
            react_1.default.createElement(_1.SnackbarMessage, { message: message }),
            react_1.default.createElement(_1.Overlay, { loading: isBusy }))));
};
Wrapper.defaultProps = {
    isBusy: false,
    isFetching: false,
    message: {},
    classes: {},
};
Wrapper.propTypes = {
    children: prop_types_1.default.object.isRequired,
    container: prop_types_1.default.bool,
    isFetching: prop_types_1.default.bool,
    isBusy: prop_types_1.default.bool,
    navBar: prop_types_1.default.object.isRequired,
    message: prop_types_1.default.any,
    classes: prop_types_1.default.object,
    version: prop_types_1.default.string,
};
exports.default = Wrapper;
